import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function MultiSelectInput({ data, selected, name, placeHolderText, onChange }) {
  const [inputValue, setInputValue] = useState('');
  const onTagsChange = (event, values) => {
    onChange(values);
  };

  return (
    <Autocomplete
      required
      multiple
      id={name}
      options={data}
      getOptionLabel={option => option.fullName}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={selected || []}
      onChange={onTagsChange}
      filterSelectedOptions
      inputValue={inputValue}
      getOptionDisabled={option => selected.length >= 10}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="filled"
            color="success"
            label={option.fullName}
            {...getTagProps({ index })}
            sx={{ borderRadius: '0.30rem' }}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          placeholder={selected.length === 0 ? placeHolderText : ''}
          sx={{ backgroundColor: 'white' }}
          color="success"
        />
      )}
      renderOption={(props, option, state) => (
        <li {...props} key={option.id}>
          {option.fullName}
        </li>
      )}
    />
  );
}
